export default "__VITE_ASSET__e1a79140__"